<template>
  <b-card class="statistics-component">
    <b-row align-h="between">
      <b-col cols="auto">
        <h1>Stadistics</h1>
      </b-col>
      <b-col cols="auto">
        <b-dropdown right text="Filters" variant="primary" boundary="window">
          <b-dropdown-form>
            <b-form-checkbox-group v-model="selected" v-for="({ title }, key) in stadistics" :key="key">
              <b-form-checkbox :value="title">{{ title }}</b-form-checkbox>
            </b-form-checkbox-group>
          </b-dropdown-form>
        </b-dropdown>
      </b-col>
    </b-row>
    <div class="statistics-chart-container">
      <vue-apex-charts v-if="series.length" :options="chartOptions" :series="series" type="bar" />
    </div>
    <mixn ref="mixin" />
  </b-card>
</template>

<script>
import { BDropdownForm, BCard, BImg, BAvatar, BCardText, BDropdown, BFormCheckbox } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import mixn from "@/components/mixn.vue";

export default {
  components: {
    mixn,
    BDropdownForm,
    BCard,
    BAvatar,
    BImg,
    BCardText,
    VueApexCharts,
    BDropdown,
    BFormCheckbox
  },
  props: {
    stadistics: {
      type: Array,
      default: () => [],
      required: true
    },
  },
  watch: {
    stadistics() {
      this.filterData()
    },
    selected() {
      this.filterData(true)
    }
  },
  methods: {
    isMobileDevice() {
      return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    formatCurrency(value) {
      // Formatear el valor con puntos como separadores de miles y signo de dólar
      return '$' + value.toLocaleString('en-US');
    },
    filterData(hasBeenSelected = false) {
      this.stadisticProps = this.stadistics
      this.series = [{
        data: this.stadistics
          .filter(({ title }) => !hasBeenSelected || this.selected.length === 0 || this.selected.includes(title))
          .map(({ value, title }) => ({ x: title, y: value }))
      }];
    },
  },
  data() {
    return {
      series: [],
      stadisticProps: [],
      selected: [],
      chartOptions: {
        chart: {
          height: this.isMobileDevice() ? 350 : 300,
          type: 'bar',
        },
        colors: [],
        plotOptions: {
          bar: {
            borderRadius: 10,
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        tooltip: {
          y: {
            title: {
              formatter: (val, opt) => {
                const stadisticProps = this.stadisticProps
                const stadistic = stadisticProps.find((stadistic) => stadistic.title == opt.w.globals.labels[opt.dataPointIndex])?.description
                return stadistic + ':'
              }
            },
            formatter: (val) => {
              return this.formatCurrency(val);
            }
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#333'],
            fontSize: '16px', // Ajusta el tamaño de la letra aquí
          },
          formatter: (val, opt) => {
            const formattedValue = this.formatCurrency(val);
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + formattedValue;
          },
          offsetX: 0,
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        xaxis: {
          labels: {
            show: false
          },
          // categories: []
        },
        responsive: [{
          breakpoint: 767,
          options: {
            chart: {
              height: 350
            },
            dataLabels: {
              style: {
                fontSize: '14px'
              }
            }
          }
        }, {
          breakpoint: 480,
          options: {
            chart: {
              height: 400
            },
            dataLabels: {
              style: {
                fontSize: '12px'
              }
            }
          }
        }, {
          breakpoint: 360,
          options: {
            chart: {
              height: 450
            },
            dataLabels: {
              style: {
                fontSize: '11px'
              }
            }
          }
        }]
      },
    }
  }
};
</script>